import { useState } from "react";
import { UserInfoList } from "./UserInfoList/UserInfoList";
import { Wrapper } from "./UserList.style";
import { UserSearch } from "./UserSearch/UserSearch";
import { PaginationBox } from "components/Pagination/PaginationBox";

// 회원검색 :: (http://localhost:3000/manage/user)
export const UserList = () => {
  const [userList, setUserMoveList] = useState([]);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [searchData, setSearchData] = useState({});

  return (
    <Wrapper>
      <div>
        <UserSearch
          setUserMoveList={setUserMoveList}
          setPage={setPage}
          currentPage={page}
          pageSize={size}
          setSearchData={setSearchData}
          searchData={searchData}
        />
        <UserInfoList
          userList={userList}
          setPage={setPage}
          setSize={setSize}
          searchData={searchData}
        />

        {userList.length !== 0 && (
          <PaginationBox
            totalItemsCount={userList[0]?.cnt}
            page={page}
            setPage={setPage}
            size={size}
          />
        )}
      </div>
    </Wrapper>
  );
};
